import type { Translation } from '../types.ts';
import type en from '../en/delivery.ts';

export default {
    settings: {
        title: 'Bezorgmomenten',
        intro: 'De dagen en tijdvakken waaruit een klant bij het afrekenen kiest. Bij afhalen wordt er niet naar gevraagd.',
        saved: 'Bezorgmomenten opgeslagen',
        weekdays: {
            mon: 'Maandag',
            tue: 'Dinsdag',
            wed: 'Woensdag',
            thu: 'Donderdag',
            fri: 'Vrijdag',
            sat: 'Zaterdag',
            sun: 'Zondag',
        },
        schedule: {
            title: 'Weekschema',
            intro: 'De tijdvakken waaruit een klant per dag van de week kan kiezen. Op een dag zonder tijdvakken wordt niet bezorgd.',
            noDelivery: 'Geen bezorging',
            noWindows: 'Er zijn nog geen tijdvakken, dus een klant heeft geen bezorgmoment om uit te kiezen.',
            from: 'Van',
            until: 'Tot',
            addWindow: 'Tijdvak toevoegen',
            removeWindow: 'Tijdvak verwijderen',
        },
        rules: {
            title: 'Bestelregels',
            cutoff: 'Uiterlijk bestellen vóór',
            leadDays: 'Levertijd (dagen)',
            leadDaysHint: 'Van een bestelling vóór de besteltijd tot de eerste bezorgdag. Bij 0 wordt dezelfde dag nog bezorgd.',
            horizonDays: 'Vooruit boeken (dagen)',
            horizonDaysHint: 'Hoeveel dagen vooruit een klant een bezorgmoment kan kiezen, 1 tot 90.',
            cutoffHelp: {
                sameDay: 'Bestellingen vóór {time} worden vanaf dezelfde dag bezorgd; na {time} vanaf de volgende dag.',
                nextDay: 'Bestellingen vóór {time} worden vanaf morgen bezorgd; na {time} vanaf overmorgen.',
                later: 'Bestellingen vóór {time} worden vanaf {days} dagen later bezorgd; na {time} vanaf {next} dagen later.',
            },
        },
        closed: {
            title: 'Gesloten dagen',
            intro: 'Extra dagen zonder bezorging, zoals feestdagen. De {link} wordt al automatisch overgeslagen, die hoef je hier niet toe te voegen.',
            closureLink: 'vakantiesluiting',
            date: 'Datum',
            add: 'Datum toevoegen',
            remove: '{date} verwijderen',
            none: 'Geen gesloten dagen.',
        },
    },
} satisfies Translation<typeof en>;
